import React from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { BsFileEarmarkExcelFill } from "react-icons/bs";
import translate from "i18n/translate";
const ExportButton = ({ reports, children }) => {
  reports = [{ data: [...reports] }];
  const handleExport = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert each report to a worksheet
    reports.forEach((report, index) => {
      const worksheet = XLSX.utils.json_to_sheet(report.data);
      XLSX.utils.book_append_sheet(workbook, worksheet, `Report ${index + 1}`);
    });

    // Generate a binary string from the workbook
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a Blob from the binary string
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    // Save the file using file-saver
    saveAs(blob, "reports.xlsx");
  };

  return (
    <IconButton
      onClick={handleExport}
      disabled={reports[0].data.length === 0}
      title="Export to Excel"
      sx={{
        margin: 0,
        padding: "6px",
        minWidth: "32px",
        height: "32px",
        borderRadius: "6px",
        backgroundColor: "#f5f5f5",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#e8e8e8",
          transform: "translateY(-1px)",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        },
        "&:active": {
          transform: "translateY(0)",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        },
        "&:disabled": {
          backgroundColor: "#f5f5f5",
          opacity: 0.5,
        },
      }}
    >
      <BsFileEarmarkExcelFill size={20} color="#217346" />
    </IconButton>
  );
};

export default ExportButton;
